/* eslint-disable no-restricted-globals */
import { useContext } from 'react';
import { InboundContext } from '../../../../context/InboundContext';
import { FormGroup } from '../../../common';
import { Heading } from '../../../styledComponents';
import styles from '../FormContainer.module.css';
import RadioButtonGroup from '../../../common/RadioButtonGroup/RadioButtonGroup';
import getPlaceholderForQuestion from './helpers/getPlaceholderForQuestion';
import MultipleOptionsQuestion from './MultipleOptionsQuestion/MultipleOptionsQuestion';

type AmbassadorAnswerType = {
  question: string;
  answer: string;
};

type AmbassadorProgramQuestionsProps = {
  ambassadorQuestions: AmbassadorAnswerType[];
  setAmbassadorQuestions: React.Dispatch<React.SetStateAction<AmbassadorAnswerType[]>>;
};

export default function AmbassadorProgramQuestions({
  ambassadorQuestions,
  setAmbassadorQuestions,
}: AmbassadorProgramQuestionsProps) {
  const { inboundData, t } = useContext(InboundContext);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    if (e.target.value.length > 500) return;
    setAmbassadorQuestions((prev) => {
      return prev.map((que, i) => {
        if (i === index) {
          return { ...que, answer: e.target.value };
        }
        return que;
      });
    });
  };

  const checkIfAllQuestionsAreEmpty = () => {
    return inboundData?.formSetupPage?.ambassadorProgramQuestions?.every((question) => question?.isActive === false);
  };

  if (!inboundData?.formSetupPage?.ambassadorProgramQuestions || checkIfAllQuestionsAreEmpty()) {
    return null;
  }

  return (
    <div className={styles.formSection}>
      <Heading as="h3" fontWeight="500" fontSize="16px" color="#353535" textTransform="uppercase">
        {t('ambassadorQuestionHeader')}
      </Heading>
      {inboundData?.formSetupPage?.ambassadorProgramQuestions?.map((que, index: number) => {
        if (que.isActive) {
          if (['yesNoAnswer'].includes(que.questionType)) {
            return (
              <RadioButtonGroup
                value={ambassadorQuestions[index]?.answer}
                setValue={(v) =>
                  setAmbassadorQuestions((prev) => {
                    return prev.map((data, i) => {
                      if (i === index) {
                        return { ...data, answer: v };
                      }
                      return data;
                    });
                  })
                }
                label={que.question}
                key={index}
                name={`radio-${index}`}
                required={que.isRequired}
              />
            );
          }
          if (que.questionType === 'checkbox' || que.questionType === 'radio') {
            return (
              <MultipleOptionsQuestion
                key={index}
                question={que}
                setValue={(v) =>
                  setAmbassadorQuestions((prev) => {
                    return prev.map((data, i) => {
                      if (i === index) {
                        return { ...data, answer: v };
                      }
                      return data;
                    });
                  })
                }
                value={ambassadorQuestions[index]?.answer}
              />
            );
          }
          return (
            <FormGroup
              displayAsTextArea={que.questionType === 'longAnswer'}
              key={index}
              label={`${que.question}`}
              type="text"
              placeholder={getPlaceholderForQuestion(que.question)}
              value={ambassadorQuestions[index]?.answer}
              onChange={(e) => handleInputChange(e, index)}
              rightLabel={index === 0 ? '' : `${ambassadorQuestions[index]?.answer.length}/500`}
              errorText=""
              required={que.isRequired}
            />
          );
        }
        return null;
      })}
    </div>
  );
}
